import axios from 'axios';
import { useScraperStore } from '@/store/scraperStore';

import { API_BASE } from './apiBase';

export async function scrapeWebsite(websiteUrl: string) {
  const store = useScraperStore();
  try {
    const response = await axios.post(`${API_BASE}/v2/scraper`, {
      siteUrl: websiteUrl
    });

    const id = response.data;

    store.setDeepAnalysisId(id);

    console.log(response.data);

    let deepAnalysisResponse = await axios.post(`${API_BASE}/v2/deepanalysis`, {
      id: id
    });

    let status = deepAnalysisResponse.data.Status;

    const intervalId = setInterval(async () => {
      try {
        deepAnalysisResponse = await axios.post(`${API_BASE}/v2/deepanalysis`, {
          id: id
        });
        status = deepAnalysisResponse.data.Status;

        store.$patch({ Status: status });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const errorMessage = error.response
            ? `Server Error: ${error.response.status}`
            : 'Network Error';
          alert(errorMessage);
          console.error(error.message);
          store.$patch({ Status: { Percent: 0, Text: errorMessage } });
          clearInterval(intervalId);
        }
      }

      if (status && status.Percent >= 100) {
        clearInterval(intervalId);
      }
    }, 1000);

    while (status && status.Percent < 100) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }

    console.log('deep analysis', deepAnalysisResponse.data);
    return deepAnalysisResponse.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
